module.exports = __webpack_public_path__ + "static/media/Impreza-Hawk-GD-Sedan.f82b2c21.webp";